import { useState } from 'react';

export const useLatest = <T>(value: T, predicate: (value: T) => boolean = (v) => !!v): T => {
  const [latest, setLatest] = useState(value);
  if (predicate(value) && value !== latest) {
    setLatest(value);
  }

  return latest;
}